import CalendarDateModel from "./CalendarDateModel.js";
export default class RestrictionSettingsModel
{
    /**
     * @param handler {function}
     */
    constructor(handler)
    {
        this.handler = handler;
    }
    /**
     * @param dayNames {string[]}
     * @return {(function(*, *): void)|*}
     */
    static closeOutDays(dayNames)
    {
        /**
         * @param calendarDateModel {CalendarDateModel}
         * @param instance {RestrictionSettingsModel}
         */
        const handler = function (calendarDateModel, instance) {
            const dayName = calendarDateModel.getDateInFormat('{day}').toLowerCase();
            if (dayNames.includes(dayName)) {
                calendarDateModel.setIsAvailable(false);
            }
            return false;
        };
        return new RestrictionSettingsModel(handler);
    }
}
